import { useState } from "react";
import { AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";
import { shortDate } from "./format";

const RepGroup = ({ group }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-xl bg-slate-800/60 ring-1 ring-white/5" data-testid={`zero-value-rep-${group.rep.replace(/\s+/g, "-").toLowerCase()}`}>
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left" data-testid={`zero-value-rep-toggle-${group.rep.replace(/\s+/g, "-").toLowerCase()}`}>
        <span className="flex items-center gap-3">
          <span className="font-heading text-lg font-black tracking-wide text-rose-300">{group.rep}</span>
          <span className="text-sm text-slate-400">Zero value</span>
        </span>
        <span className="flex items-center gap-2">
          <span className="font-mono text-xl font-bold text-slate-50" data-testid={`zero-value-rep-count-${group.rep.replace(/\s+/g, "-").toLowerCase()}`}>{group.count}</span>
          <span className="text-xs text-slate-400">job{group.count === 1 ? "" : "s"}</span>
          {open ? <ChevronUp className="h-4 w-4 text-slate-500" /> : <ChevronDown className="h-4 w-4 text-slate-500" />}
        </span>
      </button>
      {open && (
        <ul className="divide-y divide-white/5 border-t border-white/5 px-4 text-sm">
          {group.jobs.map((j) => (
            <li key={j.job_id} className="flex items-center justify-between gap-3 py-2" data-testid={`zero-value-job-${j.job_id}`}>
              <span className="flex min-w-0 flex-1 items-center gap-2">
                <span className="shrink-0 font-mono font-bold text-cyan-300">#{j.job_id}</span>
                <span className="truncate text-slate-300" title={j.customer}>{j.customer}</span>
              </span>
              <span className="flex shrink-0 items-center gap-2 text-xs text-slate-500">
                <span className="hidden max-w-[90px] truncate sm:inline" title={j.status}>{j.status}</span>
                <span>{shortDate(j.date_received)}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export const ZeroValuePanel = ({ groups, year }) => {
  const total = groups.reduce((s, g) => s + g.count, 0);
  return (
    <div className="min-w-0 rounded-2xl bg-slate-900/70 p-6 ring-1 ring-white/5" data-testid="zero-value-panel">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Zero-value jobs by rep</p>
          <p className="mt-0.5 text-sm text-slate-500">Open {year} jobs with €0 on the order — need pricing before they can be invoiced</p>
        </div>
        <span className={`flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-bold ring-1 ${total ? "bg-rose-500/15 text-rose-300 ring-rose-500/30" : "bg-emerald-500/15 text-emerald-300 ring-emerald-500/30"}`} data-testid="zero-value-total">
          <AlertTriangle className="h-4 w-4" /> {total}
        </span>
      </div>
      {groups.length === 0 ? (
        <p className="py-6 text-center text-sm text-slate-500" data-testid="zero-value-empty">Every open job has a value. Nice.</p>
      ) : (
        <div className="grid gap-2 sm:grid-cols-2">
          {groups.map((g) => <RepGroup key={g.rep} group={g} />)}
        </div>
      )}
    </div>
  );
};
